import React from 'react';
import { cn } from '@/lib/utils';

const SettingsSkeleton: React.FC = () => {
  return (
    <div className="space-y-6 animate-pulse">
      {/* Header */}
      <div className="bg-dark-200 rounded-2xl p-6 lg:p-8 border border-dark-300">
        <div className="flex items-start justify-between">
          <div>
            <div className="h-8 w-32 bg-dark-300 rounded-lg mb-2"></div>
            <div className="h-4 w-48 bg-dark-300 rounded-lg"></div>
          </div>
        </div>
      </div>

      {/* Settings Panel */}
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Sidebar */}
        <div className="lg:col-span-1">
          <div className="bg-dark-200 rounded-2xl p-4 border border-dark-300">
            <div className="space-y-1">
              {[1, 2, 3].map((i) => (
                <div key={i} className="w-full h-10 bg-dark-300 rounded-xl"></div>
              ))}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="lg:col-span-3">
          {/* Personal Info Card */}
          <div className="bg-dark-200 rounded-2xl p-6 border border-dark-300 mb-6">
            <div className="flex items-center justify-between mb-8">
              <div className="h-7 w-40 bg-dark-300 rounded-lg"></div>
              <div className="h-10 w-32 bg-dark-300 rounded-lg"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="space-y-2">
                  <div className="h-5 w-24 bg-dark-300 rounded-lg"></div>
                  <div className="h-10 w-full bg-dark-300 rounded-lg"></div>
                </div>
              ))}
            </div>
          </div>

          {/* Social Links Card */}
          <div className="bg-dark-200 rounded-2xl p-6 border border-dark-300 mb-6">
            <div className="flex items-center justify-between mb-6">
              <div className="h-7 w-64 bg-dark-300 rounded-lg"></div>
              <div className="h-10 w-32 bg-dark-300 rounded-lg"></div>
            </div>
            <div className="h-4 w-full bg-dark-300 rounded-lg mb-6"></div>
            <div className="space-y-4">
              {[1, 2, 3].map((i) => (
                <div key={i} className="space-y-2">
                  <div className="h-5 w-32 bg-dark-300 rounded-lg"></div>
                  <div className="h-10 w-full bg-dark-300 rounded-lg"></div>
                </div>
              ))}
            </div>
          </div>

          {/* Delete Account Card */}
          <div className="bg-dark-200 rounded-2xl p-6 border border-dark-300">
            <div className="flex items-start justify-between">
              <div>
                <div className="h-7 w-40 bg-dark-300 rounded-lg mb-2"></div>
                <div className="h-4 w-64 bg-dark-300 rounded-lg"></div>
              </div>
              <div className="h-10 w-32 bg-dark-300 rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsSkeleton;